module.exports = __webpack_public_path__ + "img/huiyuan.b0f5765c.png";